function Page() {
    var page = {
        resultsList: null,
        $navbar: $('.landfinder .navbar'),
        navbarHeight: $('.landfinder .navbar').outerHeight(),

        init: function() {
            var self = this;

            $(document).ready(function() {
                self.ready();
                self.scroll();
            });

            $(window)
                .on('load', function() {
                    self.load();
                    self.scroll();
                })
                .on('resize', function() {
                    self.resize();
                })
                .on('scroll', function() {
                    self.scroll();
                });

            window.addEventListener('orientationchange', function() {
                self.orientationChange();
            });

            return this;
        },

        debounce: function(func, wait, immediate) {
            var timeout;

            return function() {
                var context = this,
                    args = arguments;
                var later = function() {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        },

        createCookie: function(name, value, days) {
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
                var expires = '; expires=' + date.toGMTString();
            } else {
                var expires = '';
            }

            document.cookie = name + '=' + value + expires + '; path=/';
        },

        readCookie: function(name) {
            var nameEQ = name + '=';
            var ca = document.cookie.split(';');

            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }

            return null;
        },

        eraseCookie: function(name) {
            var self = this;

            self.createCookie(name, '', -1);
        },

        resetVars: function() {
            var self = this;

            self.winWidth = $(window).width();
            self.winHeight = $(window).height();
        },

        resize: function() {
            var self = this;

            self.resetVars();
        },

        orientationChange: function() {
            try {
                $('#price-slider').nstSlider('refresh');
                $('#area-slider').nstSlider('refresh');
                $('#frontage-slider').nstSlider('refresh');
            } catch (err) {}
        },

        nstSliderOptions: function(selector) {
            var o = {
                crossable_handles: false,
                rounding: 1,
                left_grip_selector: '.leftGrip',
                right_grip_selector: '.rightGrip',
                value_bar_selector: '.bar',
                highlight: {
                    grip_class: '.gripHighlighted',
                    panel_selector: '.highlightPanel'
                },
                value_changed_callback: function(cause, leftValue, rightValue) {
                    var l = parseInt(leftValue, 10);
                    var r = parseInt(rightValue, 10);

                    // Update labels
                    $(selector)
                        .siblings('.leftLabel')
                        .text(l);
                    $(selector)
                        .siblings('.rightLabel')
                        .text(r);

                    // Update hidden range field values
                    $(selector + '-min').attr('value', l);
                    $(selector + '-max').attr('value', r);
                }
            };

            return o;
        },

        ready: function() {
            var self = this;

            $('#corridor').SumoSelect();
            $('#developer').SumoSelect();

            $('.landfinder .btn-action').on('click', function() {
                $(this).toggleClass('btn-action--loading');
            });

            $('.landfinder .menu').offCanvasMenu();

            var $table = $('#results');
            $table.stickyTableLandfinder();

            // $( ".landfinder select" ).customDropdown();
            // $( ".landfinder input[type='checkbox']" ).customCheckbox();

            // FILTERS
            // Applied when you hit Save, not before

            $('#price-slider').nstSlider(self.nstSliderOptions('#price-slider'));
            $('#area-slider').nstSlider(self.nstSliderOptions('#area-slider'));
            $('#frontage-slider').nstSlider(self.nstSliderOptions('#frontage-slider'));

            // List.js
            var listOptions = {
                valueNames: [
                    'td_listing',
                    'td_suburb',
                    'td_estate',
                    'td_corridor',
                    'td_developer',
                    'td_stage',
                    'td_lot',
                    'td_size',
                    'td_frontage',
                    { attr: 'data-price', name: 'td_price' }, // Use data attribute not contents of table cell
                    'td_availability'
                ]
            };

            //TODO
            self.resultsList = null; //new List('main', listOptions ); // Container ("main") must wrap search field

            // Apply filters
            $('#filters .btn-primary').on('pointerup', function(e) {
                e.stopPropagation();
                e.preventDefault();

                // Add loading overlay
                $('body').addClass('loading');

                // Close menu
                $('.menu').offCanvasMenu('close');

                // Reset filters
                self.resultsList.filter();

                var corridor = $('#corridor').val(),
                    priceMin = $('#price-slider-min').val() || $('#price-slider-min').attr('min'),
                    priceMax = $('#price-slider-max').val() || $('#price-slider-min').attr('max'),
                    areaMin = $('#area-slider-min').val() || $('#area-slider-min').attr('min'),
                    areaMax = $('#area-slider-max').val() || $('#area-slider-min').attr('max'),
                    frontageMin = $('#frontage-slider-min').val() || $('#frontage-slider-min').attr('min'),
                    frontageMax = $('#frontage-slider-max').val() || $('#frontage-slider-min').attr('max'),
                    developer = $('#developer').val(),
                    availableOnly = $('#available-only').prop('checked');

                self.resultsList.filter(function(item) {
                    var v = item.values();

                    var found = false;
                    for (var i = 0; i < corridor.length; i++) {
                        if (corridor[i] == v.td_corridor) {
                            found = true;
                        }
                    }

                    var frontage = parseInt($(v.td_frontage).text());

                    if (
                        (found || corridor == 'All') &&
                        v.td_price >= parseInt(priceMin, 10) &&
                        v.td_price <= parseInt(priceMax, 10) &&
                        v.td_size >= parseInt(areaMin, 10) &&
                        v.td_size <= parseInt(areaMax, 10) &&
                        frontage >= parseInt(frontageMin, 10) &&
                        frontage <= parseInt(frontageMax, 10) &&
                        (v.td_developer == developer || developer == 'All')
                        //&&
                        //( availableOnly == false || ( availableOnly == true && v.td_availability == "For Sale" ) )
                    ) {
                        return true;
                    } else {
                        return false;
                    }
                });

                // Remove loading overlay
                $('body').removeClass('loading');
            });

            // SETTINGS
            // Applied instantly

            // Toggle columns
            $("[data-toggle='column']").on('change', function() {
                var id = $(this).data('target');
                var $th = $(".table th[data-column='" + id + "']");
                var $cells = $('.table td:nth-child(' + ($th.index() + 1) + ')');
                if (this.checked) {
                    $th.show();
                    $cells.show();
                } else {
                    $th.hide();
                    $cells.hide();
                }
                $table.stickyTableLandfinder('setColumnWidths');
            });

            // Sorting
            $('#sort, #sort-direction').on('change', function() {
                var name = $('#sort').val();
                var dir = $('#sort-direction').val();
                self.resultsList.sort(name, { order: dir });
            });
        },

        load: function() {
            var self = this;

            $('body').removeClass('loading');
        },

        scroll: function() {
            var self = this;

            var scr = Math.max($(window).scrollTop(), 0); // Prevent elastic bounce at top
            var t = scr < self.navbarHeight ? -scr : -self.navbarHeight;

            self.$navbar.css({
                transform: 'translate(0,' + t + 'px)'
            });
        }
    };

    return page;
}

window.Page = new Page().init();

// Mini plugins
$.fn.extend({
    // Animate.css
    animateCss: function(animationName) {
        var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        this.addClass('animated ' + animationName).one(animationEnd, function() {
            $(this).removeClass('animated ' + animationName);
        });
    },

    // Add BS4 classes/elements to a checkbox
    customCheckbox: function() {
        return this.each(function() {
            var $t = $(this);
            $t.removeClass('form-check-input').addClass('custom-control-input');
            var $p = $t.parent('label');
            $p.removeClass('form-check-label').addClass('custom-control custom-checkbox');
            var $d = $("<span class='custom-control-description' />");
            $p.contents()
                .wrapAll($d)
                .end()
                .prepend($t);
            var $i = $("<span class='custom-control-indicator' />");
            $t.after($i);
        });
    },

    // Add BS4 classes to a select field
    customDropdown: function() {
        return this.each(function() {
            $(this)
                .removeClass('form-control')
                .addClass('custom-select');
        });
    }
});

// http://v4-alpha.getbootstrap.com/getting-started/browsers-devices/#internet-explorer-10-in-windows-phone-8

// Copyright 2014-2015 Twitter, Inc.
// Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
    var msViewportStyle = document.createElement('style');
    msViewportStyle.appendChild(document.createTextNode('@-ms-viewport{width:auto!important}'));
    document.head.appendChild(msViewportStyle);
}
